// extracted by mini-css-extract-plugin
export default {"mainLayout":"mainLayout_mainLayout__EMqd5","MainBody":"mainLayout_MainBody__NnIUj"};